import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import * as ObjectTypeIds from 'customer-data-objects/constants/ObjectTypeIds';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import PropertyGroupRecord from 'customer-data-objects/property/PropertyGroupRecord';
import PropertyOptionRecord from 'customer-data-objects/property/PropertyOptionRecord';
import I18n from 'I18n';
import InboundDbListsAPI from '../api/inbounddb-lists';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { List, Map as ImmutableMap, OrderedMap, OrderedSet } from 'immutable';
import getIn from 'transmute/getIn';
import sortBy from 'transmute/sortBy';
import { isFieldGrouped, getFieldGroups, getCommonField, getEventSupportsObjectTypeId, wrapSingleILSFilter, unwrapSingleILSFilter } from 'customer-data-filters-ui/strategy/InboundDbListSegStrategyUtils';
import { fetchAppObjectDefinitions, fetchAssociatedObjects, fetchListsMembershipObjects, getHasFilterFamilyAccess, makeGetFilterFamilyEntityName } from 'customer-data-filters-ui/strategy/strategyUtils';
import { getVisibleFields } from 'customer-data-filters-ui/converters/listSegClassic/listSegFields';
import AnyFormSubmissionField from 'customer-data-filters-ui/converters/listSegClassic/specialFields/AnyFormSubmissionField';
import { getDynamicFilterFamilyBasis, makeDynamicFilterFamily, parseDynamicFilterFamilyId, testDynamicFilterFamily } from 'customer-data-filters-ui/filterQueryFormat/DynamicFilterFamilies';
import { AppObjectTypeIdRegex, CustomObjectTypeIdRegex, isCustomBehavioralEventObjectTypeId, isUnifiedEventObjectTypeId, isIntegratorEventObjectTypeId } from 'customer-data-filters-ui/filterQueryFormat/ObjectTypeId';
import { InboundDbListSeg } from 'customer-data-filters-ui/filterQueryFormat/strategy/StrategyTypes';
import { getObjectSegFieldDefinitionsForFilterFamily } from '../converters/objectSeg/fieldDefinitions/ObjectSegFieldDefinitions';
import { validateCondition } from '../utils/conditionValidation';
import { getEditorFilterFamilyNameTranslation, getFilterFamilyGroupHeadingTranslation } from 'customer-data-filters-ui/utils/filterFamilyTranslationConfig';
import { EVENT_BASED_FIELD_KEYS, getEventBasedFilterFamilyFields, isEventBasedFilterFamily } from './eventBasedFilters';
import { fetchAssociationDefinitions, fetchBuiltInIntegrationsSettings, fetchStandardObjectDefinitions, fetchCustomObjectDefinitions, fetchDataForSelectedFilters, makeGetFilterFamilyTranslationKey, fetchDynamicIntegrationsSettings, fetchFrameworkBuilderUnifiedEvents, fetchCustomBehavioralEvents, getFilterFamilyObjectName, getObjectAssociationOptions, fetchIntegratorEvents, getUnifiedEventsGroupOptions } from './strategyUtils';
import { DSFilterFromObjectSeg, DSFilterToObjectSeg } from '../converters/Converters';
import { hasFieldOverrideV2, hasLimitedLegacyCTAsAccess, DEAL_LISTS_GATE, hasNonContactsCustomEvents, hasPartnerAccountLists, hasEventsForAllObjects, hasAllGates, ungatedForIntegratorEvents, hasAssociatedObjectsUsingFrameworkAppSettings, hasListMembershipObjectsUsingFrameworkAppSettings } from '../permissions/gates';
import { StrategyBase } from './StrategyBase';
import { deepFreeze } from '../utils/utils';
import ObjectDefinitionProvider from 'customer-data-filters-ui/objectDefinitionProvider/ObjectDefinitionProvider';
import { getObjectSegOperatorsForTypeStrict } from 'customer-data-filters-ui/converters/objectSeg/ObjectSegTypeToOperator';
import { isPropertyChangedEventTypeId, isPropertyChangedNameAndValueField } from './propertyChangedFilterUtils';
import PropertyChangedNameAndValueField from '../converters/objectSeg/fieldDefinitions/PropertyChangedNameAndValueField';
import SmsSubscriptionField from '../converters/listSegClassic/specialFields/SmsSubscriptionField';
import WhatsAppSubscriptionField from '../converters/listSegClassic/specialFields/WhatsAppSubscriptionField';
import { getObjectSegFieldDefinitionsForFilterFamily_v2 } from '../converters/objectSeg/fieldDefinitions/ObjectSegFieldDefinitions_v2';
import { makeEventCountField } from '../converters/specialFields/EventCountField';
import { PRIVACY_CONSENT, __ANY_LINK, __ANY_PAGE } from 'customer-data-filters-ui/converters/listSegClassic/ListSegConstants';
import FieldResolverPrivacyConsent from 'customer-data-filters-ui/filterQueryFormat/knownOptionResolvers/FieldResolverPrivacyConsent';
import { EMAIL_CAMPAIGN_URL, SITE_CONTENT
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
} from 'reference-resolvers/constants/ReferenceObjectTypes';
import { FORM } from 'customer-data-objects/constants/ObjectTypes';
import { TIMEZONE_TYPES, getDefaultTimezone } from '../utils/timezoneUtils';
import { parseDebugFilterBranchEvaluationResponse } from '../utils/parseDebugFilterBranchEvaluationResponse';
import { makeEventDateField } from '../converters/specialFields/EventDateField';
import { CATEGORY_KEYS } from '../components/dataExplorer/categorySelection/Categories';
import { jsx as _jsx } from "react/jsx-runtime";
// this is not a component file

export const defaultObjectTypeIds = [DSAssetFamilies.CONTACT_PROPERTY, DSAssetFamilies.COMPANY_PROPERTY, DSAssetFamilies.DEAL_PROPERTY, DSAssetFamilies.ENGAGEMENT_PROPERTY, DSAssetFamilies.TICKET_PROPERTY, DSAssetFamilies.PRODUCT_PROPERTY, DSAssetFamilies.LINE_ITEM_PROPERTY, DSAssetFamilies.QUOTE_PROPERTY];
function hasCustomObjects(requiredIdsByAssetFamily) {
  return Boolean(requiredIdsByAssetFamily.find((_, key) => {
    const filterFamilyBasis = getDynamicFilterFamilyBasis(key);
    return CustomObjectTypeIdRegex.test(filterFamilyBasis ? parseDynamicFilterFamilyId(filterFamilyBasis, key) : key);
  }));
}
function hasAppObjects(requiredIdsByAssetFamily) {
  return Boolean(requiredIdsByAssetFamily.find((_, key) => {
    const filterFamilyBasis = getDynamicFilterFamilyBasis(key);
    return AppObjectTypeIdRegex.test(filterFamilyBasis ? parseDynamicFilterFamilyId(filterFamilyBasis, key) : key);
  }));
}
function hasUnifiedEvents(requiredIdsByAssetFamily) {
  return Boolean(requiredIdsByAssetFamily.find((_, key) => isUnifiedEventObjectTypeId(key)));
}
function hasCustomBehavioralEvents(requiredIdsByAssetFamily) {
  return Boolean(requiredIdsByAssetFamily.find((_, key) => isCustomBehavioralEventObjectTypeId(key)));
}
function hasIntegratorEvents(requiredIdsByAssetFamily) {
  return Boolean(requiredIdsByAssetFamily.find((_, key) => isIntegratorEventObjectTypeId(key)));
}
function onMount(props, requiredIdsByAssetFamily) {
  const {
    fetchMore,
    getIsUngated,
    hasScope,
    baseFilterFamily
  } = props;
  const requests = [fetchDataForSelectedFilters(fetchMore, requiredIdsByAssetFamily), fetchAssociationDefinitions(fetchMore, baseFilterFamily)];
  if (hasCustomObjects(requiredIdsByAssetFamily) || CustomObjectTypeIdRegex.test(baseFilterFamily)) {
    requests.push(fetchCustomObjectDefinitions(fetchMore));
  }
  if (hasAppObjects(requiredIdsByAssetFamily)) {
    requests.push(fetchAppObjectDefinitions(fetchMore));
  }
  if (hasUnifiedEvents(requiredIdsByAssetFamily)) {
    requests.push(fetchFrameworkBuilderUnifiedEvents({
      fetchMore,
      getIsUngated,
      hasScope
    }));
  }
  if (hasCustomBehavioralEvents(requiredIdsByAssetFamily)) {
    requests.push(fetchCustomBehavioralEvents({
      fetchMore,
      getIsUngated,
      hasScope
    }));
  }
  if (hasIntegratorEvents(requiredIdsByAssetFamily)) {
    requests.push(fetchIntegratorEvents({
      fetchMore,
      getIsUngated,
      hasScope
    }));
  }
  requests.push(fetchStandardObjectDefinitions(fetchMore));
  return Promise.all(requests);
}
function onEditorMount(props, requiredIdsByAssetFamily) {
  const {
    fetchMore,
    getIsUngated,
    hasScope
  } = props;
  const fetches = [fetchDataForSelectedFilters(fetchMore, requiredIdsByAssetFamily, true), fetchBuiltInIntegrationsSettings(fetchMore), fetchAppObjectDefinitions(fetchMore), fetchCustomObjectDefinitions(fetchMore), fetchDynamicIntegrationsSettings(fetchMore), fetchCustomBehavioralEvents({
    fetchMore,
    getIsUngated,
    hasScope
  }), fetchIntegratorEvents({
    fetchMore,
    getIsUngated,
    hasScope
  }), fetchFrameworkBuilderUnifiedEvents({
    fetchMore,
    getIsUngated,
    hasScope
  })];
  if (hasAssociatedObjectsUsingFrameworkAppSettings()) {
    fetches.push(fetchAssociatedObjects(fetchMore));
  }
  if (hasListMembershipObjectsUsingFrameworkAppSettings()) {
    fetches.push(fetchListsMembershipObjects(fetchMore));
  }
  return Promise.all(fetches);
}
export const getFilterFamilyName = (filterFamily, props, isSameObjectAssociation = false) => {
  const getFilterFamilyEntityName = makeGetFilterFamilyEntityName(props);
  const getFilterFamilyTranslationKey = makeGetFilterFamilyTranslationKey(props.baseFilterFamily, isSameObjectAssociation);
  const translationConfig = getEditorFilterFamilyNameTranslation(filterFamily, {
    getFilterFamilyEntityName,
    getFilterFamilyTranslationKey
  });
  if (translationConfig.key.endsWith('.undefined')) {
    return '';
  }
  return unescapedText(translationConfig.key, translationConfig.options);
};
export const getFilterFamilyGroupHeading = (filterFamily, associationId, isEditor, props, isSameObjectAssociation = false) => {
  const getFilterFamilyEntityName = makeGetFilterFamilyEntityName(props);
  const getFilterFamilyTranslationKey = makeGetFilterFamilyTranslationKey(props.baseFilterFamily, isSameObjectAssociation, associationId, props.data);
  const translationConfig = getFilterFamilyGroupHeadingTranslation(filterFamily, {
    getFilterFamilyEntityName,
    getFilterFamilyTranslationKey,
    isEditor
  });
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: translationConfig.key,
    options: translationConfig.options
  });
};
function getOperatorsForType(type, filterFamily, isUngated, options) {
  return getObjectSegOperatorsForTypeStrict(type, filterFamily, isUngated, options);
}
export function getCustomObjectsFilterFamilies(customObjectDefinitions, objectAssociations) {
  if (!objectAssociations) {
    return OrderedSet();
  }
  return customObjectDefinitions.filter((objectInfo, objectTypeId) => {
    return objectAssociations.get(objectTypeId);
  }).keySeq().toSet();
}
export function getAppObjectsFilterFamilies(appObjectDefinitions, objectAssociations) {
  if (!objectAssociations) {
    return OrderedSet();
  }
  return appObjectDefinitions.filter((objectInfo, objectTypeId) => {
    return objectAssociations.get(objectTypeId);
  }).keySeq().toSet();
}
export const getEnabledAssociatedObjectTypeIds = (props, isSameObjectAssociationFilteringEnabled) => {
  const {
    baseFilterFamily,
    data,
    getIsUngated: isUngated,
    hasScope
  } = props;
  const enabledAssociatedObjects = getIn([DSAssetFamilies.ASSOCIATED_OBJECTS], data) || List();
  const standardObjectDefinitions = getIn([DSAssetFamilies.STANDARD_OBJECT_DEFINITION], data) || ImmutableMap();
  const customObjectDefinitions = getIn([DSAssetFamilies.CUSTOM_OBJECT_DEFINITION], data) || ImmutableMap();
  const appObjectDefinitions = getIn([DSAssetFamilies.APP_OBJECT_DEFINITION], data) || ImmutableMap();
  const associationDefinitions = getIn([DSAssetFamilies.ASSOCIATION_DEFINITION], data) || ImmutableMap();
  const objectAssociations = associationDefinitions.get(baseFilterFamily) || ImmutableMap();
  const standardObjectTypeIds = enabledAssociatedObjects.toArray();
  const customObjectTypeIds = getCustomObjectsFilterFamilies(customObjectDefinitions, objectAssociations);
  const appObjectTypeIds = getAppObjectsFilterFamilies(appObjectDefinitions, objectAssociations);
  const associatedObjectTypeIds = [...objectAssociations
  // Customers can turn off associations in the UI, if all associations are hidden because of user configuration,
  // we should not show the object as an associated object type
  .filter(associationSet => {
    const hasEnabledAssociation = associationSet.every(association => !(association.get('hidden') && association.get('hiddenReason') === 'USER_CONFIGURED'));
    return hasEnabledAssociation;
  }).keys()];
  if (baseFilterFamily === DSAssetFamilies.CONTACT_PROPERTY) {
    // add line item as associated object type
    // see https://git.hubteam.com/HubSpot/customer-data-filters-ui/LibraryCopy/pull/874
    associatedObjectTypeIds.push(DSAssetFamilies.LINE_ITEM_PROPERTY);
    // add product as associated object type
    // see https://git.hubteam.com/HubSpot/customer-data-filters-ui/LibraryCopy/pull/1125
    associatedObjectTypeIds.push(DSAssetFamilies.PRODUCT_PROPERTY);
  }
  const enabledAssociatedObjectTypeIds = hasAssociatedObjectsUsingFrameworkAppSettings() ? [...standardObjectTypeIds, ...customObjectTypeIds, ...appObjectTypeIds] : [...defaultObjectTypeIds, ...customObjectTypeIds, ...appObjectTypeIds, ...ObjectDefinitionProvider.getEnabledForAssociations({
    isUngated,
    hasScope
  }).map(objectDefinition => objectDefinition.get('objectTypeId'))];
  const objectDefinitions = standardObjectDefinitions.merge(customObjectDefinitions, appObjectDefinitions);
  return enabledAssociatedObjectTypeIds.filter(objectTypeId => {
    // filter out object types that are not associated with the base filter family
    if (!associatedObjectTypeIds.includes(objectTypeId)) {
      return false;
    }
    const objectDefinition = objectDefinitions === null || objectDefinitions === void 0 ? void 0 : objectDefinitions.get(objectTypeId);

    // filter out disabled object types
    if (objectDefinition !== null && objectDefinition !== void 0 && objectDefinition.disabled) {
      return false;
    }

    // filter out object types that are the same as the base filter family
    // if same object association filtering is not enabled
    if (baseFilterFamily === objectTypeId && !isSameObjectAssociationFilteringEnabled) {
      return false;
    }
    return true;
  });
};
export const getUnifiedEventsOptions = (unifiedEvents = ImmutableMap(), hasScope, getIsUngated, objectTypeId) => {
  const groups = unifiedEvents.reduce((acc, event) => {
    const hasAccess = event.get('scopes').every(scope => hasScope(scope)) && hasAllGates(event.get('gates'));
    if (hasEventsForAllObjects() && !getEventSupportsObjectTypeId(event, objectTypeId)) {
      return acc;
    }
    const categoryGroupName = event.get('categoryGroupName');
    const categoryGroupLabel = event.get('categoryGroupLabel');
    if (!acc[categoryGroupName] && hasAccess) {
      acc[categoryGroupName] = {
        text: categoryGroupLabel,
        value: makeDynamicFilterFamily(DSAssetFamilies.UNIFIED_EVENT, categoryGroupName),
        isCategoriesGroup: true
      };
    }
    return acc;
  }, {});
  return Object.values(groups);
};
function getPseudoPropertyFilterFamilyOptions(props, filterFamily) {
  const {
    hasScope,
    getIsUngated
  } = props;
  if (filterFamily !== DSAssetFamilies.CONTACT_PROPERTY) {
    return [];
  }
  const filterFamiliesOnlySupportedForContacts = ImmutableMap({
    [DSAssetFamilies.PAGE_VIEW]: getHasFilterFamilyAccess(DSAssetFamilies.PAGE_VIEW, hasScope, getIsUngated),
    [DSAssetFamilies.FORM]: getHasFilterFamilyAccess(DSAssetFamilies.FORM, hasScope, getIsUngated),
    [DSAssetFamilies.EMAIL_CAMPAIGN]: getHasFilterFamilyAccess(DSAssetFamilies.EMAIL_CAMPAIGN, hasScope, getIsUngated),
    [DSAssetFamilies.EMAIL_SUBSCRIPTION]: getHasFilterFamilyAccess(DSAssetFamilies.EMAIL_SUBSCRIPTION, hasScope, getIsUngated),
    [DSAssetFamilies.SMS_SUBSCRIPTION]: getHasFilterFamilyAccess(DSAssetFamilies.SMS_SUBSCRIPTION, hasScope, getIsUngated),
    [DSAssetFamilies.WHATSAPP_SUBSCRIPTION]: getHasFilterFamilyAccess(DSAssetFamilies.WHATSAPP_SUBSCRIPTION, hasScope, getIsUngated),
    [DSAssetFamilies.CTA]: !hasLimitedLegacyCTAsAccess(getIsUngated) && getHasFilterFamilyAccess(DSAssetFamilies.CTA, hasScope, getIsUngated),
    [DSAssetFamilies.ADS_PROPERTY]: getHasFilterFamilyAccess(DSAssetFamilies.ADS_PROPERTY, hasScope, getIsUngated),
    [DSAssetFamilies.EVENT]: getHasFilterFamilyAccess(DSAssetFamilies.EVENT, hasScope, getIsUngated)
  });
  return filterFamiliesOnlySupportedForContacts.filter(value => value).keySeq().toArray().map(marketingFilterFamily => ({
    value: marketingFilterFamily,
    text: getFilterFamilyName(marketingFilterFamily, props),
    isCategoriesGroup: false
  }));
}
function getIntegratorEventOptions(props, filterFamily) {
  const hasAccess = getHasFilterFamilyAccess(DSAssetFamilies.INTEGRATOR_EVENT, props.hasScope, props.getIsUngated);
  if (ungatedForIntegratorEvents() && filterFamily === DSAssetFamilies.CONTACT_PROPERTY && hasAccess) {
    return [{
      text: unescapedText(`newCustomerDataFilters.FilterFamilyName.${DSAssetFamilies.INTEGRATOR_EVENT}`),
      value: DSAssetFamilies.INTEGRATOR_EVENT,
      isCategoriesGroup: true
    }];
  }
  return [];
}
function getCustomBehavioralEventsOptions(props, filterFamily) {
  const hasAccess = getHasFilterFamilyAccess(DSAssetFamilies.CUSTOM_BEHAVIORAL_EVENT, props.hasScope, props.getIsUngated);
  if (filterFamily === DSAssetFamilies.CONTACT_PROPERTY && hasAccess) {
    return [{
      text: unescapedText(`newCustomerDataFilters.FilterFamilyName.${DSAssetFamilies.CUSTOM_BEHAVIORAL_EVENT}`),
      value: DSAssetFamilies.CUSTOM_BEHAVIORAL_EVENT,
      isCategoriesGroup: true
    }];
  }
  const hasCustomBehavioralEventSupport =
  // this allowlist should keep up to date with https://git.hubteam.com/HubSpot/events-ui/blob/master/events-ui/static/js/constants/interfaces.ts#L9-L15
  [ObjectTypeIds.COMPANY_TYPE_ID, ObjectTypeIds.DEAL_TYPE_ID, ObjectTypeIds.TICKET_TYPE_ID].includes(filterFamily) || CustomObjectTypeIdRegex.test(filterFamily);
  if (hasNonContactsCustomEvents(props.getIsUngated) && hasCustomBehavioralEventSupport && hasAccess) {
    return [{
      text: unescapedText(`newCustomerDataFilters.FilterFamilyName.${DSAssetFamilies.CUSTOM_BEHAVIORAL_EVENT}`),
      value: DSAssetFamilies.CUSTOM_BEHAVIORAL_EVENT,
      isCategoriesGroup: true
    }];
  }
  return [];
}
function getCustomEventOptions(props, filterFamily) {
  if (filterFamily === DSAssetFamilies.CONTACT_PROPERTY || hasEventsForAllObjects()) {
    if (getHasFilterFamilyAccess(DSAssetFamilies.UNIFIED_EVENT, props.hasScope, props.getIsUngated)) {
      return getUnifiedEventsOptions(props.data.get(DSAssetFamilies.UNIFIED_EVENT), props.hasScope, props.getIsUngated, filterFamily);
    }
  }
  return [];
}
function getMarketingInteractionsOptions(props, filterFamily) {
  const pseudoPropertyFilterFamilyOptions = getPseudoPropertyFilterFamilyOptions(props, filterFamily);
  const customBehavioralEventOptions = getCustomBehavioralEventsOptions(props, filterFamily);
  const customEventOptions = getCustomEventOptions(props, filterFamily);
  const integratorEventOptions = getIntegratorEventOptions(props, filterFamily);
  return [...pseudoPropertyFilterFamilyOptions, ...customBehavioralEventOptions, ...customEventOptions, ...integratorEventOptions];
}
export const isEnabledForListMembershipsUsingAllowlist = (filterFamily, getIsUngated) => {
  if (getIsUngated(DEAL_LISTS_GATE) && filterFamily === ObjectTypeIds.DEAL_TYPE_ID) {
    return true;
  }
  if (CustomObjectTypeIdRegex.test(filterFamily)) {
    return true;
  }
  if (filterFamily === ObjectTypeIds.PARTNER_CLIENT_TYPE_ID) {
    return true;
  }
  if (hasPartnerAccountLists(getIsUngated) && filterFamily === ObjectTypeIds.PARTNER_ACCOUNT_TYPE_ID) {
    return true;
  }
  return [ObjectTypeIds.CONTACT_TYPE_ID, ObjectTypeIds.COMPANY_TYPE_ID, ObjectTypeIds.ORDER_TYPE_ID, ObjectTypeIds.CART_TYPE_ID, ObjectTypeIds.TICKET_TYPE_ID, ObjectTypeIds.SERVICE_TYPE_ID, ObjectTypeIds.COURSE_TYPE_ID, ObjectTypeIds.LISTING_TYPE_ID, ObjectTypeIds.APPOINTMENT_TYPE_ID].includes(filterFamily);
};
export const isEnabledForListsMembershipUsingFrameworkAppSettings = (filterFamily, data) => {
  const enabledListMembershipObjects = getIn([DSAssetFamilies.LIST_MEMBERSHIP_OBJECTS], data) || List();
  if (enabledListMembershipObjects.includes(filterFamily)) {
    return true;
  }
  if (CustomObjectTypeIdRegex.test(filterFamily)) {
    return true;
  }
  return false;
};
export const getIsEnabledForListMemberships = (filterFamily, data, getIsUngated) => {
  return hasListMembershipObjectsUsingFrameworkAppSettings() ? isEnabledForListsMembershipUsingFrameworkAppSettings(filterFamily, data) : isEnabledForListMembershipsUsingAllowlist(filterFamily, getIsUngated);
};
const isEnabledForImports = filterFamily => {
  return [ObjectTypeIds.CONTACT_TYPE_ID, ObjectTypeIds.COMPANY_TYPE_ID, ObjectTypeIds.DEAL_TYPE_ID, ObjectTypeIds.TICKET_TYPE_ID].includes(filterFamily) || CustomObjectTypeIdRegex.test(filterFamily);
};
const isEnabledForDatasets = filterFamily => {
  return [ObjectTypeIds.CONTACT_TYPE_ID, ObjectTypeIds.COMPANY_TYPE_ID, ObjectTypeIds.DEAL_TYPE_ID, ObjectTypeIds.TICKET_TYPE_ID].includes(filterFamily);
};
function getAssetMembershipAndEnrollmentOptions(props, filterFamily) {
  const {
    data,
    hasScope,
    getIsUngated
  } = props;
  let dynamicFilterFamilies = OrderedMap({
    [makeDynamicFilterFamily(DSAssetFamilies.DATASET, filterFamily)]: isEnabledForDatasets(filterFamily) && getHasFilterFamilyAccess(DSAssetFamilies.DATASET, hasScope, getIsUngated),
    [makeDynamicFilterFamily(DSAssetFamilies.IN_LIST, filterFamily)]: getIsEnabledForListMemberships(filterFamily, data, getIsUngated) && getHasFilterFamilyAccess(DSAssetFamilies.IN_LIST, hasScope, getIsUngated),
    [makeDynamicFilterFamily(DSAssetFamilies.IMPORT, filterFamily)]: isEnabledForImports(filterFamily) && getHasFilterFamilyAccess(DSAssetFamilies.IMPORT, hasScope, getIsUngated)
  });
  if (filterFamily === DSAssetFamilies.CONTACT_PROPERTY) {
    dynamicFilterFamilies = dynamicFilterFamilies.set(DSAssetFamilies.WORKFLOW, getHasFilterFamilyAccess(DSAssetFamilies.WORKFLOW, hasScope, getIsUngated));
  }
  return dynamicFilterFamilies.filter(value => value).keySeq().toArray().map(dynamicFilterFamily => ({
    value: dynamicFilterFamily,
    text: getFilterFamilyName(dynamicFilterFamily, props)
  }));
}
function getIntegrationEventsFromData(integrationsData = OrderedMap(), appId = undefined) {
  const integrationEvents = integrationsData.valueSeq().toArray();
  if (appId) {
    return integrationEvents.filter(event => {
      if (appId) {
        return getIn(['wrappedObject', 'appId'], event) === appId;
      }
      return true;
    });
  }
  return integrationEvents;
}
function getIntegrationAppOptions(props) {
  const {
    data
  } = props;
  const options = [];
  if (getIn([DSAssetFamilies.SURVEY_MONKEY_SETTING, 'enabled', 'metadata', 'value'], data)) {
    options.push({
      text: unescapedText(`newCustomerDataFilters.FilterFamilyName.${DSAssetFamilies.SURVEY_MONKEY_GROUP}`),
      value: `${DSAssetFamilies.INTEGRATION_APP}-${DSAssetFamilies.SURVEY_MONKEY_GROUP}`,
      isCategoriesGroup: true
    });
  }
  if (getIn([DSAssetFamilies.GOTO_WEBINAR_SETTING, 'enabled', 'metadata', 'value'], data)) {
    options.push({
      text: unescapedText(`newCustomerDataFilters.FilterFamilyName.${DSAssetFamilies.GOTO_WEBINAR_GROUP}`),
      value: `${DSAssetFamilies.INTEGRATION_APP}-${DSAssetFamilies.GOTO_WEBINAR_GROUP}`,
      isCategoriesGroup: true
    });
  }
  const dynamicIntegrationEvents = getIntegrationEventsFromData(data.get(DSAssetFamilies.INTEGRATION));
  const dynamicIntegrationAppOptions = dynamicIntegrationEvents.reduce((acc, event) => {
    const appId = getIn(['wrappedObject', 'appId'], event);
    const appName = getIn(['wrappedObject', 'appName'], event);
    // @ts-expect-error ts-migrate(2538) FIXME: Type 'unknown' cannot be used as an index type.
    acc[appId] = {
      text: appName,
      value: `${DSAssetFamilies.INTEGRATION_APP}-${appId}`,
      isCategoriesGroup: true
    };
    return acc;
  }, {});
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  options.push(...Object.values(dynamicIntegrationAppOptions));
  return options;
}
export function getGroupedFilterFamilyOptions(props, categoryGroupName, selectedObjectType, {
  integrationAppId
} = {}) {
  if (testDynamicFilterFamily(DSAssetFamilies.UNIFIED_EVENT, categoryGroupName)) {
    return getUnifiedEventsGroupOptions(parseDynamicFilterFamilyId(DSAssetFamilies.UNIFIED_EVENT, categoryGroupName), props, selectedObjectType.filterFamily, DSAssetFamilies.UNIFIED_EVENT);
  }
  if (categoryGroupName === DSAssetFamilies.CUSTOM_BEHAVIORAL_EVENT) {
    const customBehavioralEvents = props.data.get(DSAssetFamilies.CUSTOM_BEHAVIORAL_EVENT);
    return getCustomBehavioralEventsGroupOptions(customBehavioralEvents, selectedObjectType.filterFamily);
  }
  if (categoryGroupName === DSAssetFamilies.INTEGRATOR_EVENT) {
    const integratorEvents = props.data.get(DSAssetFamilies.INTEGRATOR_EVENT);
    return getIntegratorEventsGroupOptions(integratorEvents, selectedObjectType.filterFamily);
  }
  if (categoryGroupName.includes(DSAssetFamilies.INTEGRATION_APP)) {
    return getIntegrationAppEventOptions(props, integrationAppId);
  }
  return [];
}
function getIntegrationAppEventOptions(props, appId) {
  if (appId === DSAssetFamilies.SURVEY_MONKEY_GROUP) {
    return [{
      text: unescapedText(`newCustomerDataFilters.FilterFamilyName.${DSAssetFamilies.SURVEY_MONKEY_GROUP}`),
      options: [{
        value: DSAssetFamilies.SURVEY_MONKEY_QUESTION,
        text: getFilterFamilyName(DSAssetFamilies.SURVEY_MONKEY_QUESTION, props)
      }, {
        value: DSAssetFamilies.SURVEY_MONKEY_SURVEY,
        text: getFilterFamilyName(DSAssetFamilies.SURVEY_MONKEY_SURVEY, props)
      }]
    }];
  }
  if (appId === DSAssetFamilies.GOTO_WEBINAR_GROUP) {
    return [{
      text: unescapedText(`newCustomerDataFilters.FilterFamilyName.${DSAssetFamilies.GOTO_WEBINAR_GROUP}`),
      options: [{
        value: DSAssetFamilies.GOTO_WEBINAR_WEBINAR,
        text: getFilterFamilyName(DSAssetFamilies.GOTO_WEBINAR_WEBINAR, props)
      }]
    }];
  }
  const {
    data
  } = props;
  const events = getIntegrationEventsFromData(data.get(DSAssetFamilies.INTEGRATION),
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
  parseInt(appId, 10));
  return [{
    text: getIn([0, 'wrappedObject', 'appName'], events) || '',
    options: events.map(event => {
      const integrationFamily = event.get('type');
      return {
        value: integrationFamily,
        text: getFilterFamilyName(integrationFamily, props)
      };
    })
  }];
}
function getCustomBehavioralEventsGroupOptions(customBehavioralEvents, filterFamily) {
  const options = customBehavioralEvents.valueSeq().toArray().filter(customBehavioralEvent => customBehavioralEvent.primaryObjectTypeId === filterFamily).map(customBehavioralEvent => ({
    value: customBehavioralEvent.objectTypeId,
    text: customBehavioralEvent.label
  })).sort(({
    text
  }, {
    text: text2
  }) => text.localeCompare(text2));
  return [{
    text: unescapedText(`newCustomerDataFilters.FilterFamilyName.${DSAssetFamilies.CUSTOM_BEHAVIORAL_EVENT}`),
    options
  }];
}
function getIntegratorEventsGroupOptions(integratorEvents, filterFamily) {
  const options = integratorEvents.valueSeq().toArray().filter(integratorEvent => integratorEvent.primaryObjectTypeId === filterFamily).map(integratorEvent => ({
    value: integratorEvent.objectTypeId,
    text: integratorEvent.label
  })).sort(({
    text
  }, {
    text: text2
  }) => text.localeCompare(text2));
  return [{
    text: unescapedText(`newCustomerDataFilters.FilterFamilyName.${DSAssetFamilies.INTEGRATOR_EVENT}`),
    options
  }];
}
const getFilterFamilyOptionsByFilterFamilyInfo = (props, filterFamilyInfo) => {
  const {
    filterFamily,
    isObjectOwnFilterBranch
  } = filterFamilyInfo;
  const options = [{
    category: CATEGORY_KEYS.PROPERTIES,
    text: I18n.text('newCustomerDataFilters.FilterFamilyGroup.currentObject'),
    options: [{
      text: getFilterFamilyName(filterFamily, props),
      value: filterFamily,
      isAssociation: !isObjectOwnFilterBranch
    }]
  }];
  const assetMembershipAndEnrollmentOptions = getAssetMembershipAndEnrollmentOptions(props, filterFamily);
  if (assetMembershipAndEnrollmentOptions.length) {
    options.push({
      category: CATEGORY_KEYS.MEMBERSHIPS,
      text: I18n.text('newCustomerDataFilters.FilterFamilyGroup.assetMembershipAndEnrollment'),
      options: assetMembershipAndEnrollmentOptions
    });
  }
  const marketingInteractionsOptions = getMarketingInteractionsOptions(props, filterFamily);
  if (marketingInteractionsOptions.length) {
    options.push({
      category: CATEGORY_KEYS.EVENTS,
      text: I18n.text('newCustomerDataFilters.FilterFamilyGroup.marketingInteractions'),
      options: marketingInteractionsOptions
    });
  }
  if (filterFamily === DSAssetFamilies.CONTACT_PROPERTY) {
    options.push({
      category: CATEGORY_KEYS.EVENTS,
      text: I18n.text('newCustomerDataFilters.FilterFamilyGroup.integration'),
      options: getIntegrationAppOptions(props)
    });
  }
  return options;
};
function getFilterFamilyOptions(props, filterFamilyInfo) {
  const options = getFilterFamilyOptionsByFilterFamilyInfo(props, filterFamilyInfo);
  return options.map(entry => Object.assign({}, entry, {
    options: sortBy(
    // @ts-expect-error sortBy has wrong type
    o => o.text.toLowerCase(), entry.options)
  }));
}
const getIntegrationFields = (assetFamily, data) => {
  const integrationId = parseDynamicFilterFamilyId(DSAssetFamilies.INTEGRATION, assetFamily);
  return data.getIn([DSAssetFamilies.INTEGRATION_PROPERTY, integrationId]);
};
const getFields = (assetFamily, props) => {
  if (!assetFamily || isFieldGrouped(assetFamily)) {
    return undefined;
  }
  const {
    data,
    hasScope
  } = props;
  let fields = data.get(assetFamily);
  if (testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, assetFamily)) {
    fields = getIntegrationFields(assetFamily, data);
  }
  const scopes = {
    'crm-views-all': hasScope('crm-views-all')
  };
  const visibleFields = getVisibleFields(fields, assetFamily, scopes);

  // TODO: do we need all those checks?
  if (visibleFields && visibleFields.size === 0 && fields && fields.size > 0) {
    return undefined;
  }
  return visibleFields;
};
export const getRefinementFields = assetFamily => {
  if (assetFamily !== DSAssetFamilies.UNIFIED_EVENT) {
    return undefined;
  }
  const REFINEMENT_FIELDS = Object.freeze({
    [DSAssetFamilies.UNIFIED_EVENT]: {
      [EVENT_BASED_FIELD_KEYS.EVENT_DATE]: makeEventDateField(DSAssetFamilies.UNIFIED_EVENT),
      [EVENT_BASED_FIELD_KEYS.EVENT_COUNT]: makeEventCountField(DSAssetFamilies.UNIFIED_EVENT)
    }
  });
  return REFINEMENT_FIELDS[assetFamily];
};
export const getRefinementFieldGroups = (assetFamily, props) => {
  if (isEventBasedFilterFamily(assetFamily)) {
    const fields = getEventBasedFilterFamilyFields(assetFamily, props.data, null, true);
    return ImmutableMap({
      asset_event_properties: PropertyGroupRecord({
        displayName: I18n.text(`newCustomerDataFilters.specialGroups.${assetFamily}.asset_event_properties`),
        name: 'asset_event_properties',
        properties: fields.toList()
      })
    });
  }
  return undefined;
};
export const getSpecialFieldOptions = () => {
  const anyFormSubmissionField = AnyFormSubmissionField();
  return {
    [EMAIL_CAMPAIGN_URL]: () => List.of(PropertyOptionRecord({
      label: unescapedText('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.anyLink'),
      value: __ANY_LINK
    })),
    [SITE_CONTENT]: filterFamily => {
      if (filterFamily !== FORM) {
        return List();
      }
      return List.of(PropertyOptionRecord({
        label: unescapedText('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.anyPage'),
        value: __ANY_PAGE
      }));
    },
    [DSAssetFamilies.FORM]: filterFamily => {
      if (filterFamily !== FORM) {
        return List();
      }
      return List.of(PropertyOptionRecord({
        value: anyFormSubmissionField.name,
        label: anyFormSubmissionField.label
      }));
    }
  };
};
export const getReferenceResolvers = resolvers => {
  const base = ImmutableMap({
    [PRIVACY_CONSENT]: FieldResolverPrivacyConsent
  });
  return ObjectDefinitionProvider.getAll().reduce((map, objectDefinition) => {
    const objectTypeId = objectDefinition.get('objectTypeId');
    const referenceType = objectDefinition.get('referenceObjectType');
    return map.merge({
      [objectTypeId]: resolvers.get(referenceType),
      [referenceType]: resolvers.get(referenceType)
    });
  }, base);
};
const getCtaField = (assetFamily, id, data, fetchMore) => {
  if (assetFamily === DSAssetFamilies.CTA_TO_PLACEMENT) {
    // Fetch missing CTA to placement conversions. Note that the
    // reference-resolver automatically batches and deduplicates requests.
    // https://git.hubteam.com/HubSpot/customer-data-filters-ui/LibraryCopy/pull/184
    if (!getIn([DSAssetFamilies.CTA_TO_PLACEMENT, id], data)) {
      fetchMore({
        variables: {
          assetFamily: DSAssetFamilies.CTA_TO_PLACEMENT,
          ids: [id]
        }
      });
    }
  }

  // get non placement CTA field
  const nonPlacementCTAField = getIn([DSAssetFamilies.CTA_TO_PLACEMENT, id], data);
  if (nonPlacementCTAField) {
    if (nonPlacementCTAField.userHasNoAccess) {
      return nonPlacementCTAField;
    }
    const placementId = getIn(['metadata', 'placementGuid'], nonPlacementCTAField);
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'unknown' is not assignable to type 'string |... Remove this comment to see the full error message
    return getIn([DSAssetFamilies.CTA, placementId], data);
  }

  // get placement CTA field
  return getIn([DSAssetFamilies.CTA, id], data);
};
export const getField = (assetFamily, id, defaultField, props) => {
  const {
    data,
    fetchMore
  } = props;
  const commonField = getCommonField(assetFamily, id, defaultField, props);
  if (commonField) {
    return commonField;
  }
  if (assetFamily === DSAssetFamilies.CTA_TO_PLACEMENT || assetFamily === DSAssetFamilies.CTA) {
    return getCtaField(assetFamily, id, data, fetchMore) || defaultField;
  }
  if (isPropertyChangedEventTypeId(assetFamily) && isPropertyChangedNameAndValueField(id)) {
    return PropertyChangedNameAndValueField();
  }
  if (assetFamily === DSAssetFamilies.SMS_SUBSCRIPTION) {
    return SmsSubscriptionField();
  }
  if (assetFamily === DSAssetFamilies.WHATSAPP_SUBSCRIPTION) {
    return WhatsAppSubscriptionField();
  }
  return data.getIn([assetFamily, String(id)]) || defaultField;
};
export const getCustomFieldsForAssetFamily = __assetFamily => {
  return ImmutableMap();
};
export const evaluateFiltersForObject = (internalDraftValue, filters, objectTypeId, objectId) => {
  return InboundDbListsAPI.evaluateFiltersForObject([filters], objectTypeId, +objectId).then(response => parseDebugFilterBranchEvaluationResponse(response, objectTypeId, internalDraftValue));
};
export const getRequiredFields = filterFamily => {
  if (isPropertyChangedEventTypeId(filterFamily)) {
    return new Set([PropertyChangedNameAndValueField().name]);
  }
  return new Set();
};
const serializer = {
  fromFormat: DSFilterFromObjectSeg,
  toFormat: DSFilterToObjectSeg
};
export class InboundDbListSegStrategy extends StrategyBase {
  configure(customConfig) {
    const newStrategy = new InboundDbListSegStrategy(this.strategyDefinition);
    newStrategy.applyCustomConfig(customConfig);
    return deepFreeze(newStrategy);
  }
  getEnabledAssociatedObjectTypeIds(props, isSameObjectAssociationFilteringEnabled) {
    return getEnabledAssociatedObjectTypeIds(props, isSameObjectAssociationFilteringEnabled).filter(objectTypeId => {
      return this.getFilterFamilyOptions(props, {
        filterFamily: objectTypeId,
        isObjectOwnFilterBranch: false
      }, isSameObjectAssociationFilteringEnabled).length !== 0;
    });
  }
  getFields(filterFamily, props, includeAssociations) {
    const baseFields = super.getFields(filterFamily, props, includeAssociations);
    if (isPropertyChangedEventTypeId(filterFamily)) {
      const propertyNameAndValueField = PropertyChangedNameAndValueField();
      if (baseFields) {
        const fields = baseFields.delete('hs_name').delete('hs_value').delete('hs_previous_value').set(propertyNameAndValueField.name, propertyNameAndValueField);
        return fields;
      } else {
        return ImmutableMap({
          [propertyNameAndValueField.name]: propertyNameAndValueField
        });
      }
    }
    return baseFields;
  }
}

// note: when this gets refactored, re-add test coverage. Spying on
// the functions is not working so we are ensuing that the right function
// reference is set, this does not work when we have this switch
export const getFieldDefinitions = (filterFamily, isUngated) => {
  return isUngated && hasFieldOverrideV2(isUngated) ? getObjectSegFieldDefinitionsForFilterFamily_v2(filterFamily) : getObjectSegFieldDefinitionsForFilterFamily(filterFamily);
};
export const getTimezoneOptions = () => {
  return [TIMEZONE_TYPES.PORTAL_TZ, TIMEZONE_TYPES.UTC];
};
export const InboundDbListSegStrategyInstance = deepFreeze(new InboundDbListSegStrategy({
  onMount,
  onEditorMount,
  getCustomFieldsForAssetFamily,
  getDefaultTimezone,
  getTimezoneOptions,
  getField,
  getFieldDefinitions,
  getFieldGroups,
  getRefinementFieldGroups,
  getRefinementFields,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(assetFamily: $tsMigrateAny, props: $tsMigra... Remove this comment to see the full error message
  getFields,
  getRequiredFields,
  getFilterFamilyOptions,
  getGroupedFilterFamilyOptions,
  getFilterFamilyName,
  getFilterFamilyGroupHeading,
  getFilterFamilyObjectName,
  // Fiscal-flavor preset dynamic date filters won't work without these changes:
  // https://git.hubteam.com/HubSpot/crm-filters/issues/2573
  getIsFiscalYearEnabled: () => false,
  getOperatorsForType,
  getReferenceResolvers,
  getSpecialFieldOptions,
  getObjectAssociationOptions,
  serializer,
  wrapSingleFilter: wrapSingleILSFilter,
  unwrapSingleFilter: unwrapSingleILSFilter,
  strategyType: InboundDbListSeg,
  validateOperator: validateCondition,
  isIncludeObjectsWithNoValueSetCheckboxEnabled: true,
  getHasFilterFamilyAccess,
  evaluateFiltersForObject,
  isNotCompletedUnifiedEventFiltersEnabled: true,
  isSameObjectAssociationFilteringEnabled: true,
  canEditLogicGroupCondition: true
}));